/** Just the two fields the ranking reads, so this stays independent of any page's row schema. */
interface AdvertiserSpendRow {
  advertiser: string;
  spend: number;
}

/**
 * Ranked by spend across the WHOLE uploaded range, not a filtered range. Colour assignment keys
 * off list position, so ranking by filtered spend would recolour a brand's series as the user
 * filters. An advertiser with no rows keeps its place at the end.
 *
 * Shared by the pathmatics pages so a brand holds one colour across all of them.
 */
export function orderAdvertisersBySpend(
  advertisers: string[],
  rows: AdvertiserSpendRow[],
): string[] {
  const spendByAdvertiser = new Map<string, number>();
  for (const row of rows) {
    spendByAdvertiser.set(row.advertiser, (spendByAdvertiser.get(row.advertiser) ?? 0) + row.spend);
  }
  return [...advertisers].sort((a, b) => {
    const spendA = spendByAdvertiser.get(a) ?? 0;
    const spendB = spendByAdvertiser.get(b) ?? 0;
    return spendB - spendA || a.localeCompare(b);
  });
}
